import {reactive, computed} from 'vue'
import dbManager from '@/tools/indexedDB'

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export function stageChat(options = {}) {
    let config = {
        maxDisplayCount: 50,
        historyRecordCount: 20,
        loadBatchSize: 20,
        reductionNumber: 5,
        ...options
    }

    // 响应式状态
    const state = reactive({
        isInitializing: false,
        totalCount: 0,
        displayMessages: [],
        selfMessages: null,
        loading: false,
        hasMore: false,
    })

    const earliestTimestamp = computed(() => {
        return state.displayMessages.reduce((timestamp, msg) => {
            return Math.min(timestamp, msg.timestamp)
        }, Infinity)
    })

    // const latestTimestamp = computed(() => {
    // 	return state.displayMessages.reduce((timestamp, msg) => {
    // 		return Math.max(timestamp, msg.timestamp)
    // 	}, 0)
    // })

    async function fetchMessageWithIndexedDB() {
        const range = IDBKeyRange.bound(
            [config.stageId, -Infinity],
            [config.stageId, Infinity],
            false,
            false,
        )
        const queryMessages = await dbManager.query('messages', {
            indexName: 'stage_time',
            range: range,
            limit: config.maxDisplayCount,
            direction: 'prev',
        })
        state.displayMessages = queryMessages.reverse()

        state.totalCount = await dbManager.count('messages', 'stage_time', range)
        // console.log(`indexedDB stageId = ${config.stageId} load messages = ${queryMessages.length}, totalCount = ${state.totalCount}`)
        // console.log(JSON.stringify(state.displayMessages))

        state.hasMore = state.displayMessages.length < state.totalCount

        await loadSelfMessages(config.roleId)

        state.isInitializing = true
        state.loading = false
    }

    function validateMessage(message) {
        const required = ['role_id', 'type', 'timestamp']
        return required.every(field => message[field] !== undefined)
    }

    function addMessage(message) {
        if (!validateMessage(message)) {
            console.warn('消息格式非法:', message)
            return
        }

        if (state.displayMessages.length < config.maxDisplayCount) {
            state.displayMessages.push(message)
        } else if (state.displayMessages.length === config.maxDisplayCount) {
            state.displayMessages.shift()
            state.displayMessages.push(message)
            state.hasMore = true
        } else {
            state.displayMessages.push(message)

            const excessNumber = state.displayMessages.length - config.maxDisplayCount
            let deleteCount
            if (excessNumber <= config.reductionNumber) {
                deleteCount = excessNumber
            } else {
                const excessLevel = Math.ceil(excessNumber / config.maxDisplayCount)
                deleteCount = config.reductionNumber * excessLevel
                deleteCount = Math.min(deleteCount, excessNumber)
            }
            state.displayMessages = state.displayMessages.slice(deleteCount)

            state.hasMore = true
        }
    }

    async function loadMore() {
        if (state.loading || !state.hasMore) return false

        state.loading = true

        await sleep(2)

        const displayLength = state.displayMessages.length
        // console.log(`displayLength, ${displayLength} totalCount ${state.totalCount}`)

        if (displayLength >= state.totalCount) {
            state.hasMore = false
            return false
        }

        const needLoad = Math.min(
            config.loadBatchSize,
            state.totalCount - displayLength
        )

        const startTime = Date.now()

        const moreMessages = await dbManager.query('messages', {
            indexName: 'stage_time',
            range: IDBKeyRange.bound(
                [config.stageId],
                [config.stageId, earliestTimestamp.value],
                false,
                true,
            ),
            limit: needLoad,
            direction: 'prev',
        })
        console.log(`indexedDB needLoad ${needLoad} get more messages ${moreMessages.length}`)

        const elapsedTime = Date.now() - startTime
        const remainingTime = Math.max(0, 1000 - elapsedTime)
        await sleep(remainingTime)

        if (moreMessages && moreMessages.length > 0) {
            state.displayMessages.unshift(...moreMessages.reverse())

            if (state.displayMessages.length >= config.maxDisplayCount * 10) {
                state.hasMore = false
            } else {
                state.hasMore = state.displayMessages.length < state.totalCount
            }
        } else {
            state.hasMore = false
        }

        state.loading = false
    }

    function clearMessages() {
        state.isInitializing = false
        state.displayMessages = []
        state.totalCount = 0
        state.hasMore = false
        state.loading = false
    }

    function updateConfig(options) {
        state.config = options.config
        config = {
            ...config,
            ...options
        }
    }

    async function loadSelfMessages(roleId) {
        if (state.selfMessages === null) {
            const queryMessages = await dbManager.query('messages', {
                indexName: 'stage_role',
                range: IDBKeyRange.bound(
                    [config.stageId, roleId],
                    [config.stageId, roleId],
                    false,
                    false,
                ),
                limit: 20,
                direction: 'prev',
            })
            state.selfMessages = queryMessages.reverse()
        }
    }

    async function addSelfMessage(message) {
        if (state.selfMessages === null) {
            await loadSelfMessages()
        }
        if (state.selfMessages instanceof Array) {
            state.selfMessages.push(message)
            if (state.selfMessages.length > config.historyRecordCount) {
                state.selfMessages.shift()
            }
        }
    }

    return {
        isInitializing: computed(() => state.isInitializing),
        messages: computed(() => state.displayMessages.sort((a, b) => {
            return a.timestamp - b.timestamp
        })),
        loading: computed(() => state.loading),
        totalCount: computed(() => state.totalCount),
        selfMessages: computed(() => state.selfMessages),

        addMessage,
        addSelfMessage,
        loadMore,
        clearMessages,
        fetchMessageWithIndexedDB,
        updateConfig,
    }
}
